import { bool } from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParam } from 'react-use';

import { Alert, Text } from '@olist/united';

import { isMobileSource } from '../../constants';
import { TextLink } from '../shared/TextLink';

const PreSignupAlerts = ({ showFormError, showInvalidCnpj, showInvalidEmail }) => {
  const { t } = useTranslation();
  const sourceParam = useSearchParam('source');
  return (
    <>
      {showFormError && (
        <Alert
          data-testid="form-error-alert"
          maxWidth="510px"
          mb={8}
          messages={[t`ops, the form could not be submitted. Try again`]}
        />
      )}
      {showInvalidEmail && (
        <Alert
          data-testid="invalid-email-alert"
          variation="warning"
          maxWidth="510px"
          mb={8}
          messages={[
            <Text key="showInvalidEmail">
              <Trans>
                you already have an
                <TextLink href="https://app.olist.com/login/"> olist account</TextLink>
              </Trans>
              {', '}
              {t`we'll redirect you to the sign in page in a few seconds...`}
            </Text>,
          ]}
        />
      )}
      {showInvalidCnpj && (
        <Alert
          data-testid="invalid-cnpj-alert"
          variation="warning"
          maxWidth="510px"
          mb={8}
          messages={[
            <Text key="showInvalidCnpj">
              <Trans i18nKey="invalid cnpj, check if you already have an <2>olist account</2>">
                invalid cnpj, check if you already have an{' '}
                <TextLink href="https://app.olist.com/login/">olist account</TextLink>{' '}
              </Trans>
              {!isMobileSource(sourceParam) && (
                <Trans i18nKey="or<1>contact us</1>">
                  or
                  <TextLink href="mailto:marketing@olist.com" target="_blank" rel="noopener">
                    contact us
                  </TextLink>
                </Trans>
              )}
            </Text>,
          ]}
        />
      )}
    </>
  );
};

PreSignupAlerts.propTypes = {
  showFormError: bool.isRequired,
  showInvalidCnpj: bool.isRequired,
  showInvalidEmail: bool.isRequired,
};

export default PreSignupAlerts;
